import { FC } from "react";
import stylesCard from "@/styles/search/Search.Card.module.scss";
import socialAndBrandSvg from "@/utils/svg-icon/socialAndBrand";
import userInterfaceSvg from "@/utils/svg-icon/userInterface";

const TagsPackageType: FC<{
    isPremium: boolean;
}> = ({ isPremium }) => {
    return (
        <div className="d-flex justify-content-center">
            <div
                className={
                    isPremium
                        ? stylesCard.cardLabelPremium
                        : stylesCard.cardLabelQuality
                }
            >
                <div>
                    {isPremium ? (
                        <socialAndBrandSvg.SketchLine />
                    ) : (
                        <userInterfaceSvg.StarLine />
                    )}
                </div>
                <span style={{ color: "#000", textTransform: "capitalize" }}>
                    {isPremium ? "ONLY PREMIUM" : "ONLY QUALITY"}
                </span>
            </div>
        </div>
    );
};

export default TagsPackageType;
